import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import type { SxProps, Theme } from '@mui/material';

interface DialogCloseButtonProps {
    onClick: () => void;
    ariaLabel?: string;
    sx?: SxProps<Theme>;
}

export const DialogCloseButton = ({ onClick, ariaLabel = 'close', sx }: DialogCloseButtonProps) => (
    <IconButton
        aria-label={ariaLabel}
        onClick={onClick}
        sx={[
            {
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'grey.500',
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ]}
    >
        <CloseIcon />
    </IconButton>
);
